import { FC, useEffect } from 'react'
import { TSpecialRequestResponseProps } from './SpecialRequestResponse.types'
import styles from './SpecialRequestResponse.module.scss'
import { Alert, AlertTitle, CircularProgress, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useProcessSpecialRequestMutation } from 'lib/apollo/hooks'
import { useApolloClients } from 'lib/apollo/apolloProvider'

const SpecialRequestResponse: FC<TSpecialRequestResponseProps> = () => {
  const { token } = useParams() as { token: string }

  const { iservicesClient } = useApolloClients()

  const [processSpecialRequest, { data, loading }] =
    useProcessSpecialRequestMutation()

  useEffect(() => {
    processSpecialRequest({
      variables: { token },
      client: iservicesClient,
    })
  }, [iservicesClient, processSpecialRequest, token])

  return (
    <div className={styles.container}>
      {loading ? (
        <div className={styles.alert}>
          <Typography variant="body1" className={styles.center}>
            Processing your request...
          </Typography>
          <CircularProgress />
        </div>
      ) : (
        <Alert severity="success" variant="outlined" className={styles.alert}>
          <AlertTitle className={styles.center}>
            {`You have successfully ${
              data?.processSpecialRequest.data?.accepted
                ? 'accepted'
                : 'rejected'
            } the special request`}
          </AlertTitle>
          <Typography variant="body1" className={styles.center}>
            You can now close this window
          </Typography>
        </Alert>
      )}
    </div>
  )
}

export default SpecialRequestResponse
